export const FEATURE_FLAGS = {
  CHAT_ASSISTANT_ENABLED: 'app.chat.assistant.enabled',
  CHAT_ASSISTANT_ENABLED_CLOSE: 'app.chat.assistant.enabled.close',
  CHAT_ASSISTANT_SUBAGENT_SELECTION_ENABLED: 'app.chat.assistant.subagent.selection.enabled',
  ACTION_ITEMS_ENABLED: 'app.action.items.enabled',
  IS_ISW_ORG: 'is-isw-org',
  CHAT_FEEDBACK_V2_ENABLED: 'app.chat.feedback.v2.enabled',
  SCHEDULED_TASKS_ENABLED: 'app.scheduled.tasks.enabled',
  LEGACY_PEOPLE_FLOW_ENABLED: 'app-legacy-people-flow',
  PEOPLE_V2_ENABLED: 'app.people.v2',
  DASHBOARD_ENABLED: 'app.people.dashboards',
  SKILLS_BRANCH_OVERRIDE: 'api.skills.branch-override.enabled',
  MAINTENANCE_BANNER_ENABLED: 'app.maintenance.banner.enabled',
  HOME_PAGE_ENABLED: 'app.home.page.enabled',
  // Shared with systemzero-api — same LaunchDarkly flag key evaluated
  // independently by each service, org-scoped. Gates the primary/secondary
  // -> temporal/static ontology rename (see the platform repo's
  // feature-flag rollout plan). systemzero-data-api does not evaluate this
  // flag itself; it receives the already-evaluated decision from
  // systemzero-api on the ingestion payload.
  ONTOLOGY_TEMPORAL_STATIC_ENABLED: 'ontology.temporal.static.enabled',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
